import { InputText } from 'mailup-web-components'
import { searchState } from 'Pages/TasksList/recoil/state/search'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

export const InputSearchString = ({ onEnter }) => {
  const intl = useIntl()
  const [{ searchText }, setSearchParams] = useRecoilState(searchState)

  const handleInputChange = (e) => {
    const val = e.target.value
    setSearchParams((prev) => ({
      ...prev,
      searchText: val
    }))
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && typeof onEnter === 'function') {
      onEnter()
    }
  }

  return (
    <InputText
      placeholder={intl.formatMessage({
        id: 'Load.TriggersList.SearchTextPlaceholder'
      })}
      value={searchText}
      onChange={handleInputChange}
      onKeyPress={handleKeyPress}
      data-mu-test='search-field__search-text'
      className='test-search-field__search-text'
    />
  )
}

InputSearchString.propTypes = {
  onEnter: PropTypes.func
}
